import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IOrganisation } from '@bciti/types';
import Ajv from 'ajv';
import { of, Subject } from 'rxjs';
import { catchError, map, takeUntil, tap } from 'rxjs/operators';
import {
    clientAccessSchema,
    configuredConnectorsSchema,
    connectorQueueSchema,
    connectorsSchema,
    coreSchema,
    credentialsSchema,
    emailSchema,
    featuresSchema,
    iframemodulesSchema,
    microservicesSchema,
    noticeSchema,
    platformSchema,
    synchronizerSchema,
} from './schemas';
import { synchronizerSchemaExample } from './schemas/synchronizer.schema';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { ConfigurationType } from '@bciti/types';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';

@Component({
    selector: 'app-configuration-fixer',
    templateUrl: './configuration-fixer.component.html',
    styleUrls: ['./configuration-fixer.component.scss'],
})
export class ConfigurationFixerComponent implements OnInit {
    destroy$ = new Subject();
    ajv;

    constructor(private configService: ConfigurationService, private organisationService: OrganisationService) {
        this.ajv = new Ajv({ allErrors: true });
    }

    get configurationApi() {
        return this.configuration;
    }

    get configurationApiErrors() {
        return this.configurationErrors;
    }

    configuration;
    configurationErrors;
    configNotFound: boolean = false;
    showErrors: boolean = false;
    exampleConfig = {};
    orgAndConfigToValidate: {
        org: string;
        key: string;
    };
    organisations: IOrganisation[];

    configurationTypes: string[];

    selectedOrgansation: IOrganisation;

    cities = new FormControl();
    configurationForm = new FormControl();

    ngOnInit(): void {
        this.getOrganisations();
        this.setConfigurationType();
    }

    getConfigurationByKey(organisation: string, key: string) {
        return this.configService.getConfigurationByKey(organisation, key);
    }

    getOrganisations(): void {
        this.organisationService.getOrganisations().subscribe((organisations) => (this.organisations = organisations));
    }

    setConfigurationType() {
        this.configurationTypes = Object.values(ConfigurationType);
    }

    onOrgSelect(org) {
        console.log(org);
    }

    onConfigSelect(config) {
        console.log(config);
    }

    getSchema(config) {
        switch (config) {
            case ConfigurationType.PLATFORM:
                return { schema: platformSchema, example: {} };
            case ConfigurationType.CORE:
                return { schema: coreSchema, example: {} };
            case ConfigurationType.EMAIL:
                return { schema: emailSchema, example: {} };
            case ConfigurationType.MICROSERVICES:
                return { schema: microservicesSchema, example: {} };
            case ConfigurationType.IFRAMEMODULES:
                return { schema: iframemodulesSchema, example: {} };
            case ConfigurationType.CONNECTORS:
                return { schema: connectorsSchema, example: {} };
            case ConfigurationType.CONFIGUREDCONNECTORS:
                return { schema: configuredConnectorsSchema, example: {} };
            case ConfigurationType.CONNECTORQUEUE:
                return { schema: connectorQueueSchema, example: {} };
            case ConfigurationType.CREDENTIALS:
                return { schema: credentialsSchema, example: {} };
            case ConfigurationType.CLIENTACCESS:
                return { schema: clientAccessSchema, example: {} };
            case ConfigurationType.FEATURES:
                return { schema: featuresSchema, example: {} };
            case ConfigurationType.SYNCHRONIZER:
                return {
                    schema: synchronizerSchema,
                    example: synchronizerSchemaExample,
                };
            default:
                console.error(`Unrecognized configuration key: ${config}`);
                break;
        }
    }

    validate(): void {
        this.showErrors = false;
        this.configNotFound = false;
        this.orgAndConfigToValidate = {
            key: this.configurationForm.value,
            org: this.cities.value?.tag,
        };
        console.log(this.cities.value);
        console.log(this.configurationForm.value);

        this.getConfigurationByKey(this.cities.value?.tag, this.configurationForm.value)
            .pipe(
                takeUntil(this.destroy$),
                catchError((error) => {
                    console.error(error);
                    if (error.status === 404) {
                        this.configNotFound = true;
                    }
                    return of({});
                }),
                map((configuration) => {
                    console.log('org config: ', configuration);
                    const validate = this.ajv.compile(this.getSchema(this.configurationForm.value)?.schema);

                    // TODO: Write example configurations for each config with required (& optional fields?)
                    this.exampleConfig = this.getSchema(this.configurationForm.value)?.example;

                    if (validate(configuration)) {
                        console.log(configuration);
                        console.log(validate.schema);
                    } else {
                        this.showErrors = true;
                        this.configurationErrors = validate.errors;
                        console.log(validate.errors);
                    }

                    this.configuration = configuration;
                }),
            )
            .subscribe();
    }
}
